import PageShell from "@/components/site/PageShell";
import SEO from "@/components/site/SEO";
import JsonLd, { buildBreadcrumbs } from "@/components/site/JsonLd";
import QuoteForm from "@/components/site/QuoteForm";
export default function Cotizar() {
  return (
    <PageShell testid="page-cotizar">
      <SEO
        title="Cotiza tu Transporte | Líneas Doradas"
        description="Solicita tu cotización de transporte turístico, empresarial o de grupo con Líneas Doradas. Respuesta rápida por WhatsApp o correo."
      />
      <JsonLd
        id="breadcrumb-jsonld"
        data={buildBreadcrumbs([
          { name: "Inicio", url: "https://www.transporteenvanesybuses.com/" },
          { name: "Cotizar", url: "https://www.transporteenvanesybuses.com/cotizar" },
        ])}
      />
      <section className="relative pt-16 md:pt-24 pb-4">
        <div className="orb-gold w-[500px] h-[500px] left-[-160px] top-[80px]" />
        <div className="max-w-4xl mx-auto px-5 md:px-8 relative text-center">
          <div className="text-[#E8C87A] text-xs uppercase tracking-[0.35em] mb-4">Cotización</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.05] text-[#F5EFE0]">
            Cotiza tu servicio de <span className="italic text-gold-grad">transporte</span>
          </h1>
          <p className="text-[#F5EFE0]/70 mt-5 max-w-2xl mx-auto text-base md:text-lg leading-relaxed">
            Llena el formulario o escríbenos por WhatsApp — te respondemos en menos de 30 minutos con tu propuesta personalizada.
          </p>
        </div>
      </section>
      <QuoteForm />
    </PageShell>
  );
}
